import { appPostStructuredMessage } from '@common/utils/appUtils';
import TfnForAllCountries from '@moncler/components/clientService/TfnForAllCountries';
import analytics from '@utils/analytics';
import React from 'react';
import { useTranslation } from 'react-i18next';
const ContactPhoneBox = (props) => {
    const { t } = useTranslation();
    if (!window.contactphone || (window.country == 'JP' && window.faf)) {
        return React.createElement(React.Fragment, null);
    }
    if (props.type == 'footer') {
        return (React.createElement("div", null, window.appmode ? (React.createElement("button", { type: "button", className: "call custom-link", onClick: () => {
                appPostStructuredMessage('contactbyphone', {
                    tel: `tel://${window.contactphone}`,
                });
                analytics.contactUsOne('phone');
            } }, t('footer.clientservice.callusat', { 0: window.contactphone }))) : (React.createElement("a", { className: "call", href: `tel:${window.contactphone}`, onClick: () => {
                analytics.contactUsOne('phone');
            } }, t('footer.clientservice.callusat', { 0: window.contactphone })))));
    }
    return (React.createElement("div", { className: "row link-box line" },
        React.createElement("div", { className: "col-lg-8 col-md-6 col-sm-7 col-xs-12" },
            React.createElement("h3", { className: "link-box__title" }, t('clientservice.callus')),
            React.createElement("p", { className: "col-sm-10" },
                t('clientservice.clientadvisorsavailable'),
                " ")),
        React.createElement("div", { className: "col-lg-4 col-md-6 col-sm-5 col-xs-12 " }, window.appmode ? (React.createElement("button", { type: "button", className: "link-box__button button button--secondary call custom-link", onClick: () => {
                appPostStructuredMessage('contactbyphone', {
                    tel: `tel://${window.contactphone}`,
                });
                analytics.contactUsOne('phone');
            } },
            React.createElement("span", null, window.contactphone))) : (React.createElement("a", { className: "link-box__button button button--secondary call", href: `tel:${window.contactphone}`, onClick: () => {
                analytics.contactUsOne('phone');
            } },
            React.createElement("span", null, window.contactphone)))),
        React.createElement("div", { className: "col-12" },
            React.createElement(TfnForAllCountries, { accordion: true }))));
};
export default ContactPhoneBox;
